<template>
  <div class="comp-box">
    <span class="layer layer-child">🎯 子组件 MyChild</span>
    <div class="comp-title">
      接收 <code>v-bind="$attrs"</code> + <code>v-on="$listeners"</code>
    </div>

    <p class="comp-desc">
      本组件 props: <code>['innerMsg']</code> （只声明了 innerMsg）<br>
      <strong style="color:#1890ff;">$attrs</strong> =
      <code>{{ attrsSummary }}</code><br>
      <strong style="color:#722ed1;">$listeners</strong> =
      <code>{{ listenersSummary }}</code>
    </p>

    <!-- 实际使用透传过来的 attribute（如 placeholder、title） -->
    <div class="flex-row">
      <label>
        👇 下面这个 input 使用了透传的 placeholder（如有）<br>
        <input v-bind="$attrs" @focus="$emit('focus', $event)" @click="$emit('child-click', '来自子组件的点击')">
      </label>
      <label>
        👇 透传的自定义事件<br>
        <button class="btn" @click="$emit('custom-event', { from: 'MyChild', time: Date.now() })">
          触发 custom-event
        </button>
      </label>
    </div>

    <p class="inner-msg">
      innerMsg prop: <strong>{{ innerMsg }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MyChild',
  props: ['innerMsg'],
  computed: {
    attrsSummary() {
      return JSON.stringify(this.$attrs)
    },
    listenersSummary() {
      return Object.keys(this.$listeners).join(', ') || '(无)'
    }
  }
}
</script>

<style scoped>
.comp-box {
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
  transition: border-color .25s;
}

.layer {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.layer-child {
  background: #f6ffed;
  color: #389e0d;
}

.comp-title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
}

.comp-desc {
  font-size: 13px;
  margin-bottom: 8px;
  color: #555;
}

.comp-desc code {
  background: var(--surface-2);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #c7254e;
}

.flex-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.flex-row > * {
  flex: 1;
  min-width: 180px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #555;
}

input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(31, 45, 61, 0.06);
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border .2s;
}

input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, .2);
}

.btn {
  display: inline-block;
  padding: 8px 20px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background .2s;
}

.btn:hover {
  background: #40a9ff;
}

.btn:active {
  background: #096dd9;
}

.inner-msg {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
}
</style>
